import { useAuth } from "../provider/useAuth";
import React, { FC } from "react";
import { Navigate } from "react-router-dom";

export const ProtectedRoute: FC<any> = ({ children, isAdmin, isManagerRoute }) => {
	const { user } = useAuth();

	if (
		isAdmin &&
		(!user ||
			(user.role !== 'ADMIN' &&
				user.role !== 'CONSULTATION' &&
				!(isManagerRoute && user.role === 'MANAGER')))
	) {
		return <Navigate to='/' replace />;
	}

	return children;
};
